/**
 * Angular imports.
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * This component is used to display the confirmation popup for expired Survey.
 */
@Component({
  selector: 'app-survey-confirmation-modal',
  templateUrl: './survey-confirmation-modal.component.html',
  styleUrls: ['./survey-confirmation-modal.component.scss']
})
export class SurveyConfirmationModalComponent {
  /**
   * Get required data from parent component.
   */
  @Input() surveyError: string;
  @Input() title: string;
  @Input() cancel: string;
  @Input() ok: string;

  /**
   * Send data to parent component.
   */
  @Output() cancelPopup = new EventEmitter();
  @Output() getNewSurvey = new EventEmitter();

  /**
   * Close modal.
   */
  hideModal(): void {
    this.cancelPopup.emit();
  }

  /**
   * Close modal.
   */

  onHidden(): void {
    this.cancelPopup.emit();

  }

/**
 * Send data to parent.
 */

  ActivateAction(): void {
    this.getNewSurvey.emit();
  }

}
